"use client";

import { useTranslations } from "next-intl";

import { ContactForm } from "@/widgets/ContactForm";
import { ModalHeader } from "@/widgets/Modal/Header";

export const CallBack = () => {
  const t = useTranslations();

  return (
    <div
      className={
        "w-full md:w-[650px] relative flex flex-col items-stretch justify-stretch"
      }
    >
      <ModalHeader title={t("Callback request")} />

      <div className={"py-16 px-12"}>
        <ContactForm email={false} />
      </div>
    </div>
  );
};

export default CallBack;
